import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const subCatbyCatTodo = createAsyncThunk('subCatbyCat', async ({ id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `subCategories-by-category/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const subCatbyCatSlice = createSlice({
    name: 'subCatbyCat',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(subCatbyCatTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(subCatbyCatTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default subCatbyCatSlice.reducer; 